import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
 
const MsalHandler = () => {
  const { instance } = useMsal();
  const navigate = useNavigate()
 
  useEffect(() => {
    instance.handleRedirectPromise().then((response) => {
      if (response) {
        instance.setActiveAccount(response.account);
        navigate('/dashboard');
 
      }
    });
  }, [instance]);
 
  return null;
};
 
export default MsalHandler;